import { useState } from "react";

import { Grid } from "@mantine/core";
import { LayoutStandard } from "components";
import ChatUserView from "./users";
import ChatMessages from "./messages";

import { ChatResponse } from "types";
import { AppUtils } from "utils";
import { useTranslation } from "react-i18next";

const ChatPage = () => {
  const { t } = useTranslation();
  const [activeChat, setActiveChat] = useState<ChatResponse | undefined>(undefined);

  return (
    <LayoutStandard padding={0} title={AppUtils.composeTabTitle(t("chat.title"))}>
      <Grid gutter={0}>
        <Grid.Col span={4} m={0} p={0}>
          <ChatUserView activeChat={activeChat} setActiveChat={setActiveChat} />
        </Grid.Col>
        <Grid.Col
          span={8}
          m={0}
          p={0}
          style={{ borderLeft: "2px solid var(--mantine-color-gray-3)" }}
        >
          <ChatMessages chat={activeChat} setActiveChat={setActiveChat} />
        </Grid.Col>
      </Grid>
    </LayoutStandard>
  );
};

export default ChatPage;
